class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resultsWrap = this.querySelector('[data-predictive-results]');
    this.form = this.querySelector('form');
    this.cache = {};
    this.currentTerm = '';

    if (!this.input || !this.resultsWrap) return;

    this.input.addEventListener('input', this.debounce((e) => this.onChange(e), 250).bind(this));
    this.input.addEventListener('focus', () => {
      if (this.input.value.trim().length > 1) this.open();
    });
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  onChange() {
    const term = this.input.value.trim();
    if (term.length < 2) {
      this.close();
      return;
    }
    this.currentTerm = term;
    this.getResults(term);
  }

  getResults(term) {
    if (this.cache[term]) {
      this.render(this.cache[term]);
      return;
    }
    const url = `${window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/'}search/suggest?q=${encodeURIComponent(term)}&section_id=predictive-search`;
    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        const html = section ? section.innerHTML : '';
        this.cache[term] = html;
        if (term === this.currentTerm) this.render(html);
      })
      .catch(() => this.close());
  }

  render(html) {
    this.resultsWrap.innerHTML = html;
    if (this.resultsWrap.querySelector('#predictive-search-results')) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.resultsWrap.classList.add('is-open');
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.resultsWrap.classList.remove('is-open');
    this.input.setAttribute('aria-expanded', 'false');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
